module.exports = __webpack_public_path__ + "static/media/42.4cad8f07.png";